import axios from 'axios';
import * as Sentry from "@sentry/browser";


let capturedEventsPromise: Array<Function> = [];
let onAnalyticsLoad = () => {
  Promise.all(capturedEventsPromise.map(fn => fn()));
};

export const piiScrub = (val: string) => {
  return val.replace(
    /(([^\/]*@[^\/]*\.[^\/]*)|([^\/]*%40[^\/]*\.[^\/]*))/g,
    '[REDACTED]'
  )
}

export const trackEvent = function (event: string, data?: Record<string, any>) {
  const trySentryErrorLog = () => {
    try {
      Sentry.captureMessage(
        'Analytics wrapper errored',
        Sentry.Severity.Error
      );
    } catch (error) {
      // Intentionally leaving this blank since there's nothing we can do at this point  
    }
  }
  // First try to use the atl-global wrapper
  try {
    if (typeof ace !== "undefined") {
      ace.analytics.Tracking.trackEvent(event, data);
    } else {
      capturedEventsPromise.push(
        () => new Promise((resolve) => {
          trackEvent(event, data);
          resolve(null);
        })
      );

      window.segmentPageReady = onAnalyticsLoad;
    }
  } catch (error) {
    trySentryErrorLog()
  }
};

/**
* Iterates through event keys, ensures that values are lowercase,
* and replaces whitespace with `-` character
**/
export const sanitizeEventProperties = function (propertiesObj) {
  let result = {};
  Object.keys(propertiesObj).map(key => {
    // do a quick check just in case values are null
    result[key] = propertiesObj[key] && propertiesObj[key].replace(/\s+/g, '-').toLowerCase();
  });
  return result;
}

export const trackGas = function (postBody) {
  const analyticsApiUrl = 'https://mgas.prod.public.atl-paas.net/v1/event';
  const options = {
    headers: {
      'content-type': 'application/json'
    },
    withCredentials: true
  };

  return axios.post(analyticsApiUrl, postBody, options)
    .then(() => Promise.resolve());
};
